// extracted by mini-css-extract-plugin
export default {"linkItem":"BentoItemLink_linkItem__0Dunv"};